import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';

export default css({
  '&.tab': {
    '&--active': {
      color: COLORS.PRIMARY500,
      border: `1px solid ${COLORS.PRIMARY500}`,
    },
    '&--error': {
      border: `1px solid ${COLORS.RED500}`,
      color: COLORS.RED500,
    },
    '&--error:hover': {
      border: `1px solid ${COLORS.RED500}`,
      color: COLORS.RED500,
      backgroundColor: COLORS.RED50,
    },
    '&--error:hover svg': {
      color: COLORS.RED500,
    },
  },
});
